export function OrderByPosition(data) {
	//order by position descendent
	data.sort(
    (d1, d2) => (d1.position > d2.position) ? 1 : (d1.position < d2.position) ? -1 : 0);
	return data
}